import styled from '@emotion/styled';

export const Container = styled.div`
  color: ${props => props.theme.colors.page.text};
  background: ${props => props.theme.colors.page.background};
  min-height: 100%;
  overflow: auto;
`;
